import { Routes } from '@angular/router';
import { KlankSwitchPage } from './klank-switch-page/klank-switch-page';
import { LettermixPage } from './lettermix-page/lettermix-page';
import { PhoneticComprehensionPage } from './phonetic-comprehension-page';
import { WordPathPage } from './word-path-page/word-path-page';

export const mechanicPhoneticComprehensionRoutes: Routes = [
  {
    path: '',
    component: PhoneticComprehensionPage,
  },
  {
    path: 'klank-switch',
    component: KlankSwitchPage,
  },
  {
    path: 'lettermix',
    component: LettermixPage,
  },
  {
    path: 'word-path',
    component: WordPathPage,
  },
];
